export const ROLE = {
  KITCHEN: '1',
  ADMIN: '2',
  VIEWER: '3',
};

export const getRoleId = () => localStorage.getItem('role_id') || '';

export const isViewer = () => getRoleId() === ROLE.VIEWER;
export const isAdmin = () => getRoleId() === ROLE.ADMIN;
export const canWrite = () => !isViewer();

export const viewerDisabledProps = (title = 'View-only role: action not allowed') =>
  isViewer()
    ? {
        disabled: true,
        'aria-disabled': true,
        title,
        onClick: (e) => { e.preventDefault(); e.stopPropagation(); },
        style: { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' },
      }
    : {};
